import {
  ApiACLRole,
  ApiAuthUser,
  ApiClient,
  ApiProject,
} from "@incendium/api";
import { useCallback, useMemo } from "react";
import { useSelectedProject } from "./useSelectedProject";
import { useSelector } from "react-redux";
import { IStoreState } from "Interfaces";
import { hasPermission as hasUserPermission } from "features/users/utils";
import { AuthTokens } from "Types/auth";

export const useUser = (t?: AuthTokens | null) => {
  const user = useSelector((state: IStoreState) => state.auth.user);
  const { selectedProject, selectedClient } = useSelectedProject();

  const isAdmin = useCallback(() => {
    if (!user) {
      return false;
    }
    return ((user as ApiAuthUser).permissions || []).some((p) =>
      p.role?.toLowerCase().includes("admin")
    );
  }, [user]);

  const hasPermission = useCallback(
    (
      role: ApiACLRole,
      write?: boolean,
      client?: ApiClient,
      project?: ApiProject
    ) => {
      if (!user) {
        return false;
      }

      const selClient = client || selectedClient;
      const selProject = project || selectedProject;

      return hasUserPermission(user, role, selClient, selProject, write);
    },
    [selectedProject, selectedClient, user]
  );

  return useMemo(
    () => ({
      user: user as ApiAuthUser,
      hasPermission,
      isAdmin,
    }),
    [user, hasPermission, isAdmin]
  );
};
